<template>
  <section>
    <b-modal width="680px" :active.sync="isCardModalActive">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title" v-if="isRoboPartsSetView">
            パーツセット「{{selectRoboPartsSet.robo_parts_set_name}}」を削除しますが、本当によろしいでしょうか？
          </p>
          <p class="card-header-title" v-else>
            ロボ内のシナリオを全て削除しますが、本当によろしいでしょうか？
          </p>
        </header>
        <div class="card-content">
          <p v-if="isRoboPartsSetView">
            <b-message type="is-danger" has-icon>
              削除されたパーツセットを復元することはできません。
            </b-message>
          </p>
          <p v-else>
            <b-message type="is-danger" has-icon>
              削除されたシナリオを復元することはできません。<br/>
              ※ロボは削除されません。
            </b-message>
          </p>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="isCardModalActive = false">いいえ</a>
          <a class="card-footer-item" @click="clickDeleteScenario()">はい</a>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  name: 'ModalDeleteListScenario',
  data () {
    return {
      isCardModalActive: false,
      scenarioDelete: null
    }
  },
  mixins: [
    controlLogMixin
  ],
  computed: {
    ...mapState('chatbot', ['scenarioTable', 'isModalDeleteListScenario', 'isRoboPartsSetView', 'selectScenario', 'selectRoboPartsSet', 'selectChatbot', 'selectScenarioName']),
    ...mapState('auth', ['user'])
  },
  watch: {
    isModalDeleteListScenario () {
      this.isCardModalActive = this.isModalDeleteListScenario
    },
    isCardModalActive () {
      this.isCardModalActive ? console.log('isCardModalActive: true') : this.$store.dispatch('chatbot/closeModalScenario')
    }
  },
  methods: {
    clickDeleteScenario () {
      this.sendControlLogRelatedChatBot('シナリオパーツ全削除', 'シナリオ編集画面にて、「シナリオを全て削除」を実行。', this.selectChatbot)
      if (this.isRoboPartsSetView) {
        this.$store.dispatch('chatbot/deleteRoboPartsSet', this.selectRoboPartsSet)
      } else {
        this.$store.dispatch('chatbot/deleteScenarioList',
          {
            companyid: this.user.companyID,
            scenarioName: this.selectScenario
          }
        ).then(() => {
          // 他のアカウントと同編集のばあいはリロードを促す
          this.$store.dispatch('virtualOffice/sendVirtualOfficeSV',
            '[RELOADSCENARIO]' + this.selectScenario
          )
        })
      }
      this.$store.dispatch('chatbot/closeModalScenario')
      this.isCardModalActive = false
      event.preventDefault()
      setTimeout(() => {
        this.$store.dispatch('chatbot/getScenario', { companyid: this.user.companyID, scenarioName: this.selectScenarioName })
        this.$store.dispatch('virtualOffice/resetReloadScenario')
      }, 700)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ui/ModalDeleteListScenario.vue